import * as React from "react";

function SvgPrice(props) {
  return <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" {...props}><path d="M12.76 3.5h-2.38v-.28a3.22 3.22 0 00-6.44 0v.28H1.56a.56.56 0 00-.56.56v9.38c0 .31.25.56.56.56h11.2c.31 0 .56-.25.56-.56V4.06a.56.56 0 00-.56-.56zM5.2 3.22a1.959 1.959 0 113.92 0v.28H5.2v-.28zm6.86 9.52h-9.8V4.76h1.68V6.3c0 .077.063.14.14.14h.98a.14.14 0 00.14-.14V4.76h3.92V6.3c0 .077.063.14.14.14h.98a.14.14 0 00.14-.14V4.76h1.68v7.98z" /></svg>;
}

export default SvgPrice;